import { render, staticRenderFns } from "./PasscodeSettings.vue?vue&type=template&id=080f4d24"
import script from "./PasscodeSettings.vue?vue&type=script&lang=js"
export * from "./PasscodeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports